const locationHref = () => window.location.href;

const navigateTo = url => window.location.assign(url);

export default { locationHref, navigateTo };
